import {createMuiTheme} from "@material-ui/core/styles";
import blue from "@material-ui/core/colors/blue";

const whiteTheme = createMuiTheme({
    palette: {
        primary: {
            // main: "#00bcd4",
            main: "#0078DF",
            light: "#FFFFFF",
            /*dark: "#22252E",
            contrastText: "#252D33"*/
        },
    },
    typography: {
        fontFamily: "Microsoft Yahei, Helvetica, sans-serif",
        fontSize: 14
    },
    overrides: {
        MuiTypography: {
            body1: {
                fontSize: 14
            }
        },
        MuiListItem: {
            button: {
                "&:hover": {
                    backgroundColor: "none"
                }
            }
        }
    }
});

const theme = createMuiTheme({
    palette: {
        primary: blue
    }
});
export default whiteTheme;
export {
    whiteTheme,
    theme
};
